import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Loader from '../../../../atoms/icons/loader';
import EmptyState from '../empty-state';
import './options-oi-change-expiry-external.m.css';

const OptionsOIChangeExpiryExternal = () => {
  const [optionOIChangeData, setOptionsOIChangeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState('');
  const [stockSelected, setStockSelected] = useState(false);
  const [indexSelected, setIndexSelected] = useState(false);

  const getOptionsOIChangeDataForQuery = async (securityType = 'stock') => {
    const response = await fetch(
      `/feapi/markets/put-call-ratio/last-expiry/options/${securityType}/200`,
    );
    return response.json();
  };

  const resultOptionsOIChangeData = useQuery(
    'getOptionsOIChangeExpiryDataExternal',
    () => getOptionsOIChangeDataForQuery(selectedFilter),
    {
      refetchInterval: 30000,
      refetchIntervalInBackground: true,
      onSuccess: (data) => {
        setOptionsOIChangeData(data?.['put-call-ratio']);
      },
      enabled: !!selectedFilter,
    },
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getOptionsOIChangeData = async () => {
      setLoading(true);
      const response = await fetch(`/feapi/markets/put-call-ratio/last-expiry/options/stock/200`);
      const data = await response.json();
      setOptionsOIChangeData(data?.['put-call-ratio']);
      setLoading(false);
    };

    getOptionsOIChangeData();
    setSelectedFilter('stock');
    setStockSelected(true);
    setIndexSelected(false);
  }, []);

  useEffect(() => {
    if (resultOptionsOIChangeData?.isSuccess) {
      setOptionsOIChangeData(resultOptionsOIChangeData?.data?.['put-call-ratio']);
    }
    setSelectedFilter('stock');
  }, []);

  const stockClickhandler = async () => {
    setLoading(true);
    setStockSelected(true);
    setIndexSelected(false);
    setSelectedFilter('stock');
    const response = await fetch(`/feapi/markets/put-call-ratio/last-expiry/options/stock/200`);
    const data = await response.json();
    setOptionsOIChangeData(data?.['put-call-ratio']);
    setLoading(false);
  };

  const indexClickhandler = async () => {
    setLoading(true);
    setStockSelected(false);
    setIndexSelected(true);
    setSelectedFilter('index');
    const response = await fetch(`/feapi/markets/put-call-ratio/last-expiry/options/index/200`);
    const data = await response.json();
    setOptionsOIChangeData(data?.['put-call-ratio']);
    setLoading(false);
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="open-interest-breakup-container">
      <div styleName="header-strip">
        <span styleName="title">OPTIONS OI CHANGE SINCE LAST EXPIRY</span>
        <div styleName="filter-btn-container">
          <button
            styleName={`filter-btn ${stockSelected ? 'filter-selected' : ''}`}
            onClick={() => {
              stockClickhandler();
              setSelectedFilter('stock');
            }}
          >
            Stock Options
          </button>
          <button
            styleName={`filter-btn ${indexSelected ? 'filter-selected' : ''}`}
            onClick={() => {
              indexClickhandler();
              setSelectedFilter('index');
            }}
          >
            Index Options
          </button>
        </div>
      </div>
      {optionOIChangeData && optionOIChangeData?.length !== 0 ? (
        <>
          {loading ? (
            <div styleName="loading-container-ext">
              <div styleName="loading-container-int">
                <Loader color={'#dadee1'} />
              </div>
            </div>
          ) : (
            <div styleName="content-container">
              <div styleName="table-body-container">
                <table className="desktop-only">
                  <thead>
                    <tr styleName="initial-header-container">
                      <th colSpan={1}></th>
                      <th colSpan={1}></th>
                      <th colSpan={4}>Open Interest</th>
                      <th colSpan={3}>PCR OI</th>
                      <th colSpan={3}>PCR Vol</th>
                    </tr>
                    <tr styleName="second-header-container">
                      <th styleName="column-title">Security</th>
                      <th styleName="column-title-alt ">
                        Spot
                        <br />
                        Price
                      </th>
                      <th styleName="column-title-alt highlighted-container">Call</th>
                      <th styleName="column-title-alt highlighted-container">Change</th>
                      <th styleName="column-title-alt highlighted-container">PUT</th>
                      <th styleName="column-title-alt highlighted-container">Change</th>
                      <th styleName="column-title-alt ">Current</th>
                      <th styleName="column-title-alt ">Previous</th>
                      <th styleName="column-title-alt ">Change</th>
                      <th styleName="column-title-alt highlighted-container">Current</th>
                      <th styleName="column-title-alt highlighted-container">Previous</th>
                      <th styleName="column-title-alt highlighted-container">Change</th>
                    </tr>
                  </thead>
                  <tbody styleName="table-body">
                    {optionOIChangeData &&
                      optionOIChangeData?.slice(0, 8)?.map((dataPoint, index) => (
                        <tr styleName="data-row" key={index}>
                          <td>
                            {dataPoint?.['symbol'] ? (
                              <span styleName="name">{dataPoint?.['symbol']}</span>
                            ) : (
                              <span styleName="name">-</span>
                            )}
                          </td>
                          <td styleName="column-value ">
                            {dataPoint['spot-price'] ? (
                              <span>{dataPoint?.['spot-price']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['call-open-interest'] ? (
                              <span>{dataPoint?.['call-open-interest']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['call-open-interest-change'] ? (
                              <span>
                                {String(dataPoint['call-open-interest-change']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {dataPoint['call-open-interest-change']}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {`+${dataPoint['call-open-interest-change']}`}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['put-open-interest'] ? (
                              <span>{dataPoint?.['put-open-interest']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['put-open-interest-change'] ? (
                              <span>
                                {String(dataPoint['put-open-interest-change']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {dataPoint['put-open-interest-change']}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {`+${dataPoint['put-open-interest-change']}`}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value ">
                            {dataPoint['pcr-open-interest-current'] ? (
                              <span>{dataPoint?.['pcr-open-interest-current']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value ">
                            {dataPoint['pcr-open-interest-previous'] ? (
                              <span>
                                {String(dataPoint['pcr-open-interest-previous']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {dataPoint['pcr-open-interest-previous']}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {`+${dataPoint['pcr-open-interest-previous']}`}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value ">
                            {dataPoint['pcr-open-interest-change'] ? (
                              <span>
                                {String(dataPoint['pcr-open-interest-change']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {dataPoint['pcr-open-interest-change']}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {`+${dataPoint['pcr-open-interest-change']}`}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['pcr-volume-current'] ? (
                              <span>{dataPoint?.['pcr-volume-current']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['pcr-volume-previous'] ? (
                              <span>
                                {String(dataPoint['pcr-volume-previous']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {dataPoint['pcr-volume-previous']}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {`+${dataPoint['pcr-volume-previous']}`}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value highlighted-container">
                            {dataPoint['pcr-volume-change'] ? (
                              <span>
                                {String(dataPoint['pcr-volume-change']).includes('-') ? (
                                  <span styleName="negative-value">
                                    {dataPoint['pcr-volume-change']}
                                  </span>
                                ) : (
                                  <span styleName="positive-value">
                                    {`+${dataPoint['pcr-volume-change']}`}
                                  </span>
                                )}
                              </span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <table className="mobile-only">
                  <thead styleName="table-header-mobile">
                    <tr>
                      <th styleName="column-title">Security</th>
                      <th styleName="column-title-alt">
                        Call
                        <br /> OI
                      </th>
                      <th styleName="column-title-alt">
                        Put
                        <br /> OI
                      </th>
                      <th styleName="column-title-alt">
                        PCR
                        <br />
                        OI
                      </th>
                      <th styleName="column-title-alt">
                        PCR <br />
                        Vol
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {optionOIChangeData &&
                      optionOIChangeData?.slice(0, 8)?.map((dataPoint, index) => (
                        <tr styleName="data-row-alt" key={index}>
                          <td>
                            {dataPoint?.['symbol'] ? (
                              <span styleName="name">{dataPoint?.['symbol']}</span>
                            ) : (
                              <span styleName="name">-</span>
                            )}
                          </td>
                          <td styleName="column-value">
                            {dataPoint?.['call-open-interest'] ? (
                              <span>{dataPoint?.['call-open-interest']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value">
                            {dataPoint?.['put-open-interest'] ? (
                              <span>{dataPoint?.['put-open-interest']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value">
                            {dataPoint?.['pcr-open-interest-current'] ? (
                              <span>{dataPoint?.['pcr-open-interest-current']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                          <td styleName="column-value">
                            {dataPoint?.['pcr-volume-current'] ? (
                              <span>{dataPoint?.['pcr-volume-current']}</span>
                            ) : (
                              <span>0.00</span>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      ) : (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState />
          </div>
        </div>
      )}
    </div>
  );
};

export default OptionsOIChangeExpiryExternal;
